import { useTranslation } from '../presentation/common/useTranslation.js';

import { ClassIcon } from './GameIcon';

/** Shared translated class display; icon-only artwork remains in ClassIcon. */
export default function HeroClass({ heroClass, variant = 'inline', className = '', fallback }) {
  const { t } = useTranslation();
  const key = String(heroClass || '').trim();
  const name = key ? t(`register.class_${key.toLowerCase()}`, { defaultValue: fallback || key }) : (fallback || t('common.adventurer', 'Abenteurer'));
  if (variant === 'identity') return <><ClassIcon classKey={key} alt="" className="dashboard-identity-icon" /><div className={`dashboard-identity-item ${className}`}><small>{t('dashboard_v2.hero_class')}</small><strong>{name}</strong></div></>;
  return <span className={className}>{name}</span>;
}
